// features/public-map/application/mapStore.ts
import { create } from 'zustand';
import { BoundingBox } from '../domain/valueObjects/BoundingBox';

type MapState = {
  container: HTMLElement | null;
  setContainer: (el: HTMLElement | null) => void;

  initialBounds: BoundingBox | null;
  bounds: BoundingBox | null;
  setBounds: (b: BoundingBox) => void;

  isSatelliteView: boolean;
  setIsSatelliteView: (isSatelliteView: boolean) => void;
};

export const useMapStore = create<MapState>((set) => ({
  container: null,
  setContainer: (el) => set({ container: el }),

  initialBounds: new BoundingBox(29.2, -98.7, 29.6, -98.3),
  bounds: new BoundingBox(29.2, -98.7, 29.6, -98.3),
  setBounds: (b) => set({ bounds: b }),

  isSatelliteView: false,
  setIsSatelliteView: (isSatelliteView) => set({ isSatelliteView }),
}));
